import { useState } from "react";

import { makePostApiCall, makePutApiCall } from "../../../shared/makeApiCall";
import UnitOfMeasuresForm from "../../../components/forms/setup/unitOfMeasures/UnitOfMeasuresForm";
import { SnackbarData, SnackbarType } from "../../../components/Snackbar";
import { generateUniqueNumber } from "../../../shared/utility";

export function UnitOfMeasuresViewModel(logout, addSnackbar) {
  const [loading, setLoading] = useState(false);
  const [unitOfMeasures, setUnitOfMeasures] = useState({ data: [] });

  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });

  const getUnitOfMeasures = async function (search, page) {
    setLoading(true);
    const payload = {
      page: page,
      search: search,
    };
    let callResult = await makePostApiCall(`unitOfMeasures`, payload);
    setLoading(false);
    if (callResult.success) {
      setUnitOfMeasures(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const createUnitOfMeasure = async function (values) {
    const payload = { ...values };
    let callResult = await makePostApiCall("createUnitOfMeasure", payload);

    if (callResult.success) {
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          "Unit of measure added",
          SnackbarType.Success,
        ),
      );
      setSlideOver({
        childComponent: null,
        open: false,
      });
      setTimeout(function () {
        getUnitOfMeasures("", 1);
      }, 1000);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const updateUnitOfMeasure = async function (unitOfMeasure, values, index) {
    let callResult = await makePutApiCall(
      `unitOfMeasures/${unitOfMeasure.id}`,
      values,
    );

    if (callResult.success) {
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          "Unit of measure updated",
          SnackbarType.Success,
        ),
      );
      setSlideOver({
        childComponent: null,
        open: false,
      });
      setTimeout(function () {
        getUnitOfMeasures("", 1);
      }, 1000);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const openAddUnitOfMeasureSlideOver = () => {
    setSlideOver({
      childComponent: (
        <UnitOfMeasuresForm
          isEdit={false}
          setOpen={setSlideOver}
          actionCall={createUnitOfMeasure}
        />
      ),
      open: true,
    });
  };

  const viewUnitOfMeasureDetails = async function (unitOfMeasure, index) {
    setSlideOver({
      childComponent: (
        <UnitOfMeasuresForm
          unitOfMeasure={unitOfMeasure}
          index={index}
          isEdit={true}
          setOpen={setSlideOver}
          actionCall={updateUnitOfMeasure}
        />
      ),
      open: true,
    });
  };

  return {
    getUnitOfMeasures,
    loading,
    unitOfMeasures,
    openAddUnitOfMeasureSlideOver,
    setSlideOver,
    slideOver,
    viewUnitOfMeasureDetails,
  };
}
